const config = {
  Auth: {
    mandatorySignIn: true,
    region: "us-east-1",
    userPoolId: "us-east-1_qXerrJEuU",
    identityPoolId: "us-east-1:8bae2a62-4cd3-4db2-8dc2-a9138bee92ed",
    userPoolWebClientId: "2t7737h8nen13s1r2cdt6bplv7"
  },
  API: {
    endpoints: [
      {
        name: "api",
        endpoint: " https://api.ketrics.com",
        region: "us-east-1"
      }
    ]
  },
  Storage: {
    region: "us-east-1",
    bucket: "ketrics-buckets-usersbucket-1sqdqzqy3c1zf",
    identityPoolId: "us-east-1:8bae2a62-4cd3-4db2-8dc2-a9138bee92ed"
  },
  cdn: {
    URL: "https://apps.ketrics.com"
  },
  aws_appsync_graphqlEndpoint: "https://graphql.ketrics.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
};

export default config;
